module.exports = __webpack_public_path__ + "assets/img/Type D2.249d2690.jpg";